
import React, { useState } from 'react'
import BtnPrincipal from 'src/components/Buttons/BtnPrincipal';
import useCotizacion from 'src/hooks/useCotizacion';
import useCustomToast from 'src/hooks/useCustomToast';
import usePtp from 'src/hooks/usePtp';
import ModalPtpPreguntas from 'src/pages/NewFinCompra/ModalPtpPreguntas';
import usePaginaPago from 'src/reducers/PaginaPago/usePaginaPago';
import { POST, guardarLead } from 'src/services';
import { Layout } from '../styleds';
import { useHistory } from 'react-router-dom';
import { urlFormaPago } from 'src/services/urls';
import useMx365 from 'src/hooks/useMx365';

let err = ""


const Mx365 = ({ codCore }) => {
  const { idCotizacion, cotizacion } = useCotizacion();
  const history = useHistory();
  const { setLoading, resetLoading, valdiarTerminos } = usePaginaPago();
  const { addWarningToast } = useCustomToast();
  const { getUrl } = useMx365(idCotizacion, cotizacion);


  const pagar365 = async () => {


    setLoading({
      loading: true,
      principal: 'Procesando',
      secundario: 'Pronto seras redireccionado a MX365',
    });


    guardarLead(idCotizacion, `PAGINA_PAGO__SELECCIONO_MX365`);

    const { url } = await getUrl();

    // err = res.hasError;

    // if (hasError) {
    //   resetLoading();
    //   addWarningToast(typeof hasError == "string" ? hasError : 'HA OCURRIDO UN PROBLEMA AL REDIRECCIONAR A PLACE TO PAY');
    //   return;
    // } else
    if (!!url) window.location.href = url;
    setTimeout( () => {  resetLoading() }, 200);
    
    
  };
  const infoBoton = cotizacion?.metodosPago.find(x => x.codCore === 'garantia365')

  return (
    <div className="row justify-content-center flex-row  py-4">
      <Layout onClick={valdiarTerminos(pagar365)}>
        <div className=' d-flex align-items-center '>
          <img
            className="img-fluid"
            style={{ width: 50 }}
            src={infoBoton?.logo}
            alt={infoBoton?.nombre}
          />
          <span className="ml-2"><h4>{infoBoton?.nombre}</h4></span>
        </div>
      </Layout>
      
      {/* <ModalPtpPreguntas /> */}
    </div>
  );
};

export default Mx365;


